export const EmployeeJobsRoutes = [
    {
        "url": "/employee-referrals",
        "name": "employee-referrals",
        "type": "frontend",
        "loginRequired": true,
        "params": {},
        "component": 'referralsComponent',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["employee-jobs"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/employee-jobs/employee-jobs.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/my-employer-jobs",
        "name": "myEmployerJobs",
        "type": "frontend",
        "loginRequired": true,
        "params": {},
        "component": 'myEmployerJobsComponent',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["employee-jobs"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/employee-jobs/employee-jobs.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=employee-jobs.routes.js.map